import axios from 'axios'
import axiosInstance from '../axiosInstance'
import { Url } from './constantUrl'
import getHeaders from './getHeaders'
import * as types from './types'
import { errorHandler } from './error/errorHandler.action'
import getHeadersformdata from './getHeaderFormdata'
import { HTTP_METHOD } from '../constants/httpMethod/HttpMethod'

export const moduleListAction = (page, id, search) => dispatch => {
  const API_URL = localStorage.getItem('countryBackendUrl')
  const baseUrl = API_URL + Url.MODULE_LIST;

  const queryParams = [];

  if (id) {
    queryParams.push(`vehicle_ids=${id}`);
  } else if (search) {
    queryParams.push(`vehicle_ids=""`);
  }
  if (search) {
    queryParams.push(`search=${search}`);
  }
  queryParams.push(`page_size=15`);
  queryParams.push(`page=${page}`);

  const url = `${baseUrl}?${queryParams.join('&')}`;

  let options = {
    method: HTTP_METHOD.GET,
    headers: getHeaders(),
    url: url
  };
  return axiosInstance(options).then(resp => {
    if (resp.status === 200 || resp.status === 201) {
      dispatch({ type: types.GET_MODULE_LIST, payload: resp?.data })
      return resp
    } else { return null }
  })
    .catch(error => {
      errorHandler(error)
    })
}

//  Searched data for module
export const moduleSearchInputAction = (params = {}) => dispatch => {
  dispatch({ type: types.MODULE_LIST_SEARCH_INPUT, payload: params })
}

// Module List Page
export const moduleListPageinputAction = (params = {}) => dispatch => {
  dispatch({ type: types.MODULE_LIST_PAGE_VALUE, payload: params })
}

export const detailsmoduleListAction = (id) => dispatch => {
  const API_URL = localStorage.getItem('countryBackendUrl')
  const url = API_URL + Url.DETAILS_MODULE_LIST + "/" + id
  let options = {
    method: HTTP_METHOD.GET,
    headers: getHeaders(),
    url: url
  };
  return axiosInstance(options).then(resp => {
    if (resp.status === 200 || resp.status === 201) {
      dispatch({ type: types.GET_DETAILS_MODULE_LIST, payload: resp?.data })
      return resp
    } else { return null }
  })
    .catch(error => {
      errorHandler(error)
    })
}

// ADD MODULE POST API

export const addModuleAction = (params = {}) => dispatch => {
  const API_URL = localStorage.getItem('countryBackendUrl')
  const url = API_URL + Url.ADD_MODULE
  const options = {
    method: 'POST',
    ...(params && { data: params }),
    headers: getHeadersformdata(),
    url
  };
  return axiosInstance(options).then(resp => {
    if (resp.status === 200 || resp.status === 201) {
      dispatch({ type: types.POST_ADD_MODULE, payload: resp })
      return resp
    } else { return null }
  }).catch(error => {
    errorHandler(error)
  })
}

// UPDATE MODULE POST API

export const updateModuleAction = (id, params = {}) => dispatch => {
  const API_URL = localStorage.getItem('countryBackendUrl')
  const url = API_URL + Url.UPDATE_MODULE + "/" + id
  const options = {
    method: HTTP_METHOD.POST,
    ...(params && { data: params }),
    headers: getHeadersformdata(),
    url
  };
  return axiosInstance(options).then(resp => {
    if (resp.status === 200 || resp.status === 201) {
      dispatch({ type: types.PUT_UPDATE_MODULE, payload: resp })
      return resp
    } else { return null }
  }).catch(error => {
    errorHandler(error)
  })
}
